import { escapeRegExp } from 'lodash'

export type Segment = { text: string; match: boolean }

const unmatched = (text: string): Segment[] => [{ text, match: false }]

/** Split `text` so each case-insensitive occurrence of any word is its own matched segment. */
export function splitByWords(text: string, words: string[]): Segment[] {
  const parts = words.filter(Boolean).map(escapeRegExp)
  if (parts.length === 0) return unmatched(text)
  const pattern = new RegExp(`(${parts.join(`|`)})`, `ig`)
  const segments: Segment[] = []
  let last = 0
  for (const hit of text.matchAll(pattern)) {
    const start = hit.index ?? 0
    if (start > last) segments.push({ text: text.slice(last, start), match: false })
    segments.push({ text: hit[0], match: true })
    last = start + hit[0].length
  }
  if (segments.length === 0) return unmatched(text)
  if (last < text.length) segments.push({ text: text.slice(last), match: false })
  return segments
}

/**
 * Mark the typed digit run inside a formatted phone number. The formatted string carries
 * punctuation, so the run is located in the digits alone and then mapped back to the
 * formatted positions it spans.
 */
export function splitByDigits(formatted: string, digits: string): Segment[] {
  if (!digits) return unmatched(formatted)
  const digitPositions: number[] = []
  for (let i = 0; i < formatted.length; i += 1) {
    if (/\d/.test(formatted[i])) digitPositions.push(i)
  }
  const onlyDigits = digitPositions.map((i) => formatted[i]).join(``)
  const at = onlyDigits.indexOf(digits)
  if (at < 0) return unmatched(formatted)
  const start = digitPositions[at]
  const end = digitPositions[at + digits.length - 1] + 1
  const segments: Segment[] = []
  if (start > 0) segments.push({ text: formatted.slice(0, start), match: false })
  segments.push({ text: formatted.slice(start, end), match: true })
  if (end < formatted.length) segments.push({ text: formatted.slice(end), match: false })
  return segments
}
